import {
	NsureClientTypeEnum,
	type NsureQuestionnaireAccessRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { z } from "zod";

// Jediné místo, které rozhoduje, zda je payload investičního dotazníku použitelný
// pro nsure access request — sdílí ho push, stará notifikační lista i timeline.
// Leaf modul bez side-effectů (žádný device/sentry/toast), aby šel importovat
// z čistých resolverů i z jejich unit testů.
const questionnaireAccessRequestSchema = z.object({
	clientType: z.nativeEnum(NsureClientTypeEnum),
	identificationNumber: z
		.union([z.string(), z.number()])
		.transform(String)
		.pipe(z.string().min(1)),
});

export const parseQuestionnaireAccessRequest = (
	data: unknown,
): NsureQuestionnaireAccessRequestDTO | null => {
	const result = questionnaireAccessRequestSchema.safeParse(data);
	return result.success ? result.data : null;
};
